const focusedElementBeforeMenu: HTMLElement|null = null
const mobileMenu = document.querySelector( '[data-mobile-menu]' ) as HTMLElement
const menuOverlay = document.querySelector( '.modal-overlay' ) as HTMLElement
const menuToggles = document.querySelectorAll( '[data-open-menu]' ) as NodeListOf<HTMLElement>

export { focusedElementBeforeMenu, mobileMenu, menuOverlay, menuToggles }
